function formatDateWithTimezone(date: Date) {
  return date.toISOString();
}

export default formatDateWithTimezone;
